import React from 'react';
import PropTypes from 'prop-types';
import styles from './WorkbenchSelect.css';

const WorkbenchSelect = ({
  isFocused = false,
  isOpen = false,
  selectedIndex = 0,
  onSelectedIndexChanged = () => undefined,
  values = [],
  isMultiSelect = false
}) => {

  const SELECT_PLACEHOLDER = 'Select a value';
  // Prepend 'empty' value to list
  const options = [{
    name: SELECT_PLACEHOLDER,
    _id: undefined
  }].concat(values);

  const previousItemArrow = isFocused ? <span className={styles.arrow}>&lt;</span> : null;
  const nextItemArrow = isFocused ? <span className={styles.arrow}>&gt;</span> : null;
  const currentValue = (
    <span className={options[selectedIndex].name === SELECT_PLACEHOLDER && !isFocused ? styles.select : styles.value}>
      {options[selectedIndex].name}
    </span>
  );
  const valueContainer = <div>{previousItemArrow} {currentValue} {nextItemArrow}</div>;

  const optionList = options.map((option, index) => {
    function handleOnClick(e) {
      e.stopPropagation();
      onSelectedIndexChanged(index, false);
    }
    const listItemClass = index === selectedIndex ? styles.selectedListItem : styles.listItem;
    return (
      <div key={index} className={listItemClass} onClick={handleOnClick}>
        {option.name}
      </div>
    );
  });

  return (
    <div tabIndex="0" className={styles.workbenchSelect}>
      {isOpen ? optionList : valueContainer}
    </div>
  );
};

WorkbenchSelect.propTypes = {
  values: PropTypes.array,
  selectedIndex: PropTypes.number,
  isFocused: PropTypes.bool,
  isOpen: PropTypes.bool,
  isMultiSelect: PropTypes.bool,
  onSelectedIndexChanged: PropTypes.func
};

export default WorkbenchSelect;
